module.exports = __webpack_public_path__ + "img/bulk_booking.cb9e256d.svg";